import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseToastPlate } from '../components/base-toast-plate/component.js';
import 'classnames';
import '../../../icon-button/esm';
import '../../../shared/esm';
import '../../../status-badge/esm';
import '@alfalab/icons-glyph/CrossMIcon';
import '../components/base-toast-plate/hooks/useCustomIcons.js';
import '../components/base-toast-plate/hooks/useDeprecatedBadge.js';
import '../components/base-toast-plate/utils/isUnsafeBadge.js';

var styles = {"actionSection":"toast-plate__actionSection_1waty","title":"toast-plate__title_1waty","closeButtonWrapper":"toast-plate__closeButtonWrapper_1waty","closeButton":"toast-plate__closeButton_1waty"};
require('./mobile.css');

var ToastPlateMobile = forwardRef(function (restProps, ref) { return React.createElement(BaseToastPlate, __assign({}, restProps, { styles: styles, ref: ref })); });

export { ToastPlateMobile };
